import { useEffect, useState } from 'react'

import { getClientPanels } from '../Contentful'

export default function useClientPanels() {
  const promise = getClientPanels()
  // console.log("test 3");
  const [clientPanels, setClientPanels] = useState(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    promise.then(result => {
      setClientPanels(result)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [clientPanels, isLoading]
}